'use client'
import styled from "styled-components";
import {Col, Container} from "react-bootstrap";
import React, {useRef, useState} from "react";
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {black, hover, white} from "@/styles/globalStyleVars";
import Title from "@/components/Title";
import SvgButton from "@/components/SvgButton";
import ProjectBox from "@/components/project/ProjectBox";
import Select, {components} from "react-select";
import SearchButton from "@/components/SearchButton";
import {usePathname} from "next/navigation";
import ThemeRow from "@/components/theme/row";
import Slider, {Slide} from "@/components/swiper";
import SweeperNav from "@/components/swiper/SweeperNav";

const prev = ` <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<circle cx="20" cy="20" r="19.5" />
<path class="path" fill-rule="evenodd" clip-rule="evenodd" d="M19.6483 27.8572C19.8435 28.0525 20.1601 28.0525 20.3554 27.8572C20.5506 27.662 20.5506 27.3454 20.3554 27.1501L13.7071 20.5018L27.5037 20.5018C27.7798 20.5018 28.0037 20.278 28.0037 20.0018C28.0037 19.7257 27.7798 19.5018 27.5037 19.5018L13.7071 19.5018L20.3554 12.8536C20.5506 12.6583 20.5506 12.3417 20.3554 12.1464C20.1601 11.9512 19.8435 11.9512 19.6483 12.1464L12.1464 19.6483C12.097 19.6977 12.06 19.755 12.0356 19.8161C12.0179 19.8605 12.0068 19.9069 12.0023 19.9539C12.0008 19.9698 12 19.9858 12 20.0018C12 20.0018 12 20.0018 12 20.0018C12 20.0194 12.0009 20.037 12.0028 20.0545C12.0073 20.0979 12.0175 20.1407 12.0334 20.1819C12.0578 20.2451 12.0954 20.3044 12.1464 20.3554L19.6483 27.8572Z" fill="black"/>
</svg>`
const next = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
                      <circle cx='20' cy='20' r='19.5' />
                      <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M20.3554 12.1464C20.1601 11.9512 19.8435 11.9512 19.6483 12.1464C19.453 12.3417 19.453 12.6583 19.6483 12.8536L26.2966 19.5018H12.5C12.2239 19.5018 12 19.7257 12 20.0018C12 20.278 12.2239 20.5018 12.5 20.5018H26.2966L19.6483 27.1501C19.453 27.3454 19.453 27.662 19.6483 27.8572C19.8435 28.0525 20.1601 28.0525 20.3554 27.8572L27.8572 20.3554C27.9067 20.3059 27.9436 20.2487 27.968 20.1876C27.9877 20.1383 27.9999 20.0852 28.0029 20.0297C28.0034 20.0204 28.0037 20.0111 28.0037 20.0018C28.0037 19.9874 28.0031 19.973 28.0018 19.9587C27.9978 19.9121 27.9873 19.866 27.9703 19.8218C27.9459 19.7585 27.9082 19.6993 27.8572 19.6483Z'
                          fill='black'
                          class="path"
                      />
                 </svg>`

const FeatureSlider = ({data,isDetails, dataOption}) => {


    const hlocation = usePathname();

    //To get the params
    const paramStatus = new URLSearchParams(hlocation.search).get("status");
    const [selectStatus, setSelectStatus] = useState('')
    const [selectType, setSelectType] = useState('')
    const [selectLocation, setSelectLocation] = useState('')
    const selectTypeInputRef = useRef();
    const selectLocationInputRef = useRef();


    let sliderRef = useRef();

    const customStyles = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: "all .2s ease",
            transform: state.selectProps.menuIsOpen && "rotate(180deg)",
        }),
        control: (base, state) => ({
            ...base,
            backgroundColor: 'transparent',
            borderColor: "#B8B8B8",
            borderRadius: 0,
            height: 60,
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                borderColor: "#222222",
                // cursor: 'pointer'
            },
        }),
        option: (styles, state) => ({
            ...styles,
            backgroundColor: state.isSelected ? hover : '#FFF',
            "&:hover": {
                backgroundColor: "transparent",
                color: hover,
                // cursor: 'pointer'
            },
            zIndex : '99999',
            position: 'relative',
        }),
        indicatorContainer: (base, state) => ({
            ...base,
            transform: state.selectProps.menuIsOpen && "rotate(180deg)"
        }),
        menu: (base) => ({
            ...base,
            zIndex: 99999, // Increase the z-index value as needed
            fontSize:'12px',
            lineHeight:'16px'
        }),

    };

    const CaretDownIcon = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="11.414" height="6.414" viewBox="0 0 11.414 6.414">
            <g id="Group_4823" data-name="Group 4823" transform="translate(10.707 0.707) rotate(90)">
                <line id="Line_9" data-name="Line 9" x2="5" y2="5" fill="none" stroke="#56575a" stroke-linecap="round" stroke-width="1"/>
                <line id="Line_10" data-name="Line 10" x1="5" y2="5" transform="translate(0 5)" fill="none" stroke="#56575a" stroke-linecap="round" stroke-width="1"/>
            </g>
        </svg>;
    };
    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <CaretDownIcon/>
            </components.DropdownIndicator>
        );
    };

    const CustomPlaceholder = ({ img,placeholder, ...props }) => {
        return (
            <div className={'custom-placeholder'}>
                <img src={img} />
                <p>{placeholder}</p>
            </div>
        );
    };




    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedArea, setSelectedArea] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const selectStatusInputRef = useRef();
    const selectAreaInputRef = useRef(null);





    const p_location = dataOption?.[0]?.filter?.project_location?.map(location => ({value: location?.value, label: location?.label}));
    const project_category = dataOption?.[0]?.filter?.project_collection?.map(location => ({value: location?.value, label: location?.label}));
    const project_status = dataOption?.[0]?.filter?.project_status?.map(location => ({value: location?.value, label: location?.label}));
    const project_type = dataOption?.[0]?.filter?.project_type?.map(location => ({value: location?.value, label: location?.label}));
    const project_area = dataOption?.[0]?.filter?.project_feature?.map(location => ({value: location?.value, label: location?.label}));



    const handleCategory = async (e) => {
        setSelectedCategory(e?.value)
        selectTypeInputRef?.current?.clearValue();
        selectAreaInputRef?.current?.clearValue();
        selectLocationInputRef?.current?.clearValue();

    }


    const handleType = async (e) => {
        setSelectedType(e?.value)
        selectAreaInputRef?.current?.clearValue();
        selectLocationInputRef?.current?.clearValue();

    };


    const handleArea = async (e) => {
        setSelectedArea(e?.value)
        selectLocationInputRef?.current?.clearValue();
    };


    const handleLocation = async (e) => {
        setSelectedLocation(e?.value)
    };


    // Check if all values are null to determine if the button should be disabled
    const isSearchDisabled = !selectedCategory && !selectedType && !selectedArea && !selectedLocation;




    return (
        <StyledBlog className='blog-slider pt-120 pb-120'>
            <div className={'shadows'}>
                <img alt={isDetails ? 'Other Project' : 'Featured Projects'} src={'/images/static/feature-pattern-bg.svg'}/>
            </div>


            {
                data && data?.length > 0 &&
                <ThemeRow rowClass={'full-title'}>
                    <Col md={12} className={'d-flex justify-content-between'}>
                        <Title text={isDetails ? 'Other Project' : 'Featured Properties'}/>
                        <div className="slider-nav">
                            <SweeperNav prevSvg={prev} prevId={'slider_prev_feature'} nextID={'slider_next_feature'} nextSvg={next}/>

                        </div>
                    </Col>
                </ThemeRow>

            }


            <Container>
                <div className={` fade-up blog-slider__slider-wrap`}>
                    <div className="blog-slider__slider-wrap__inner">

                        {
                            data && data?.length > 0 &&
                            <Slider loop={true}
                                    spaceBetween={30}
                                    slidesPerView={3}
                                    allowSlideNext={true}
                                    allowSlidePrev={true}
                                    allowTouchMove={true}
                                    speed={2000}
                                    navigationRight={'.slider_prev_feature'}
                                    navigationLeft={'.slider_next_feature'}
                                    navigation={{
                                        prevEl: '.slider_next_feature',
                                        nextEl: '.slider_prev_feature',
                                    }}
                                    modules={[Autoplay, Pagination, Navigation]}
                                    breakpoints={{
                                        300: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                        768: {
                                            slidesPerView: 2,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    ref={sliderRef}>

                                {
                                    data && data?.length > 0 &&
                                    data?.map((e,index) => {
                                        return(
                                            <Slide key={index}>
                                                <ProjectBox isSold={e?.project_list_sold} title={e?.post_title} link={`/project/${e?.post_name}`} type={e?.project_type} location={e?.project_location} img={e?.project_thumb} bedroom={e?.project_bedrooms} washroom={e?.project_list_bathrooms} rent={e?.project_category} area={e?.project_feature} />
                                            </Slide>
                                        )
                                    })
                                }
                            </Slider>
                        }

                    </div>
                </div>
            </Container>

            {
                isDetails ? null :
                    <ThemeRow rowClass={'selector_sec'}>
                        <Select
                            className={'select_to_filter'}
                            onChange={handleCategory}
                            isSearchable={false}
                            styles={customStyles}
                            components={{DropdownIndicator, Placeholder: (props) => <CustomPlaceholder img={'/images/dynamic/project/union.svg'} placeholder={'Category'} {...props} />}}
                            options={project_category}
                            placeholder={selectedCategory ? selectedCategory : paramStatus ? paramStatus : CustomPlaceholder}
                            defaultValue={selectedCategory}
                            classNamePrefix={'react-select'}

                        />
                        <Select
                            className={'select_to_filter'}
                            onChange={handleType}
                            styles={customStyles}
                            options={project_type}
                            ref={selectTypeInputRef}
                            components={{DropdownIndicator, Placeholder: (props) => <CustomPlaceholder img={'/images/dynamic/project/a3.svg'} placeholder={'Type'} {...props} />}}
                            classNamePrefix={'react-select'}
                            isSearchable={false}
                            placeholder={'Type'}
                        />
                        <Select
                            className={'select_to_filter'}
                            styles={customStyles}
                            options={project_area}
                            ref={selectAreaInputRef}
                            onChange={handleArea}
                            classNamePrefix={'react-select'}
                            components={{DropdownIndicator, Placeholder: (props) => <CustomPlaceholder img={'/images/dynamic/project/a4.svg'} placeholder={'Area(Sft)'} {...props} />}}
                            isSearchable={false}
                            placeholder={'Area(Sft)'}
                        />
                        <Select className={'select_to_filter'}
                                styles={customStyles}
                                options={p_location}
                                ref={selectLocationInputRef}
                                onChange={handleLocation}
                                classNamePrefix={'react-select'}
                                components={{DropdownIndicator, Placeholder: (props) => <CustomPlaceholder img={'/images/dynamic/project/a5.svg'} placeholder={'Location'} {...props} />}}
                                isSearchable={false}
                                placeholder={'Location'}
                        />
                        <div className={`justify-content-center align-items-center ${isSearchDisabled ? 'disabled-search-button' : ''}`}>
                            <SearchButton  width={'150px'} src={`project?category=${selectedCategory ? selectedCategory : ''}&type=${selectedType ? selectedType : ''}&area=${selectedArea ? selectedArea : ''}&location=${selectedLocation ? selectedLocation : ''}`} text={'Search'} border={`1px`} borderColor={`#1B4894`} color={`${white}`} hoverBorder={hover} hoverBackground={`${hover}`} background={'#1B4894'}/>
                        </div>
                    </ThemeRow>

            }


        </StyledBlog>
    );
};

const StyledBlog = styled.section`
    background-color: ${white};
    position: relative;
    overflow: hidden;

    .disabled-search-button {
        a {
            cursor: default;
            pointer-events: none;
            opacity: 0.7;
        }
    }

    .react-select__control {
        cursor: pointer;
    }

    .shadows {
        position: absolute;
        bottom: 50px;
        right: 0;
        height: fit-content;
    }

    .css-hlgwow {
        display: flex !important;
    }

    .sub-title {
        margin: 0 0 20px 0;
        font-weight: 500;
    }

    .full-title {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        //margin: 0 0 80px 0;


        .col-md-3 {
            padding-left: 40px !important;
            padding-right: 0px !important;
        }

    }

    .blog-title {
        padding-left: 0;

        h3 {
            text-transform: uppercase;
            font-size: 32px;
            font-weight: 900;

            span {
                color: ${hover};
            }
        }
    }

    .slider-nav {
        ul {
            display: flex;
            gap: 15px;
            .circle{
                border: 1px solid black;
                &:hover{
                    border: 1px solid ${hover};
                    
                }
            }


        }

        li {
            //height: 50px;
            //width: 50px;
            //background-color: #56575A;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            border-radius: 50%;
            //cursor: pointer;

            &:nth-of-type(1) {
                margin-right: -10px;
            }
            
         

        }
    }

    .selector_sec {
        margin-top: 80px;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.05);
        z-index: 999999 !important;
        background: ${white};
        position: relative;
        gap: 15px;
        justify-content: space-between;
        flex-wrap: unset;

        @media(max-width: 767px){
            flex-direction: column;
            .dc-btn{
                width: 100%;
            }
        }
        .select_to_filter {
            width: 100%;

            .react-select__control {
                height: 48px;
            }
        }

        .col {
            padding: 0;
        }
    }

    .hover {
        cursor: pointer;

        &:after {
            z-index: 0;
        }
    }

    svg {
        z-index: 9999;
    }

    .custom-placeholder {
        display: flex;
        align-items: center;

        svg {
            line {
                stroke: black !important;
            }
        }

        img {
            margin-right: 10px;
        }

        p {
            font-size: 14px !important;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }

    h2 {
        font-weight: 800;
    }

    svg {
        border-radius: 50px;

        #Ellipse_4378 {
            transition: all 0.7s cubic-bezier(0.4, 0, 0, 1);
            r: 26;
            //cursor: pointer;
        }

        line {
            stroke: ${black};
        }

        &:hover {
            #Ellipse_4378 {
                fill: #F16A11;
                transition: all 0.7s cubic-bezier(0.4, 0, 0, 1);
                cx: 26;
            }

            g {
                line {
                    stroke: #f9f9f9;
                }
            }
        }
    }

    .swiper-button-disabled {
        opacity: unset !important;
    }

    .swiper-button-next, .swiper-button-prev {
        position: absolute;
        height: 40px;
        width: 40px;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 99;
        background-color: #F16A11;
    }

    .swiper-button-next, .swiper-button-prev, .swiper-pagination {
        opacity: 0;
        visibility: hidden;
    }

    .swiper-initialized {
        margin-left: ${props => props.offset + 15}px;
        padding-right: ${props => props.offset + 15}px;
    }

    .blog-slider {
        position: relative;

        &__slider-wrap {
            &__inner {
                .blog-single {
                    &__inner {
                        padding-top: 115%;
                    }
                }
            }
        }
    }

    .slider-nav-mobile {
        margin-top: 80px;
    }

    .react-select__menu {
        padding: 0;
        border-radius: 0;

        ul {
            margin: 0;
            padding: 0;
        }
    }

    .react-select__control {

        border: 1px solid transparent;
        height: 45px;
        background: #F6F6F8;
        border-radius: 5px;
        padding-left: 15px;
        padding-right: 15px;

        &:hover {
            border: 1px solid transparent;
        }

        &:focus {
            border: 1px solid transparent;
        }
    }


    .react-select__indicator-separator {
        display: none;
    }

    .react-select__single-value {
        color: #56575A !important;
        font-size: 12px;
        line-height: 16px;
        font-weight: 500;
    }

    .css-b62m3t-container {
        margin-bottom: 0px;
    }

    .css-1fdsijx-ValueContainer {
        display: flex !important;
        padding: 0;
    }

    .css-1jqq78o-placeholder {
        color: ${black} !important;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        text-transform: capitalize;
    }

    @media (max-width: 767px) {
        .col {
            flex: 0 0 100%;
            max-width: 100%;
        }

        .css-b62m3t-container {
            margin-bottom: 10px !important;
        }

        .selector_sec {
            margin-top: 10px;
        }
    }
    @media (max-width: 767px) {
        .swiper-initialized {
            margin: 0;
            padding: 0;
        }

        .blog-slider {
            &__slider-wrap {
                margin: 0;
            }
        }

        .full-title {
            display: unset;
            margin: 0;

            .mobile {
                margin-bottom: 40px;
            }

            .col-md-12 {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

        }

        .blog-title {
            padding: 0;
            margin-bottom: 40px;
        }

        .blog-button {
            //margin-bottom: 40px;
        }

        .blog-single {
            .blog-single__inner {
                padding-top: calc(440 / 375 * 100%);

                &__content {
                    &__bottom {
                        h3 {
                            color: ${hover};

                            p {
                                color: #FFFFFF;
                            }
                        }
                    }
                }

                &:hover {
                    .blog-single__inner__content__bottom {
                        h3 {
                            color: #ffffff;
                        }
                    }
                }
            }

            .blog-single__inner__content__top {
                .upper, h2 {
                    left: 15px;
                    right: 15px;
                }
            }

            .blog-single__inner__content__bottom h4, .blog-single__inner__content__bottom p {
                left: 15px;
                right: 15px;
            }
        }

        .slider-nav-mobile {
            margin-top: 40px;
        }

    }

`;
export default React.memo(FeatureSlider);